export const nextTick = Promise.resolve()
